function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Combined Shape");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("defs", null);

var _ref5 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "icons",
  transform: "translate(-195.000000, -180.000000)",
  fillRule: "nonzero"
}, React.createElement("path", {
  d: "M234.669911,212.164809 L221.458624,199.987463 C219.513792,198.194837 219.513792,195.288417 221.458624,193.495792 C221.78464,193.195291 222.154349,192.937975 222.55716,192.731217 L246.230693,180.579894 C247.744525,179.802864 249.587716,179.806966 251.09746,180.590725 L274.462939,192.720536 C276.859398,193.964619 277.707952,196.76382 276.358238,198.972727 C276.135935,199.336542 275.860817,199.670699 275.540495,199.965951 L262.982514,211.54112 C287.092834,217.37563 305,239.096594 305,265 C305,295.375661 280.375661,320 250,320 C219.624339,320 195,295.375661 195,265 C195,239.944605 211.753888,218.80229 234.669911,212.164809 Z M250,306 C272.643675,306 291,287.643675 291,265 C291,242.356325 272.643675,224 250,224 C227.356325,224 209,242.356325 209,265 C209,287.643675 227.356325,306 250,306 Z",
  id: "Combined-Shape"
})));

var SvgIconJewelry = function SvgIconJewelry(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "110px",
    height: "140px",
    viewBox: "0 0 110 140",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconJewelry, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-jewelry.0476b190.svg";
export { ForwardRef as ReactComponent };